import { FC, ReactNode } from 'react';

import { Flex } from 'antd';
import classNames from 'classnames';

import styles from './TimeLineItem.module.scss';

interface ITimeLineItemProps {
	icon: ReactNode;
	isActive: boolean;
	title: string;
	description: string;
	onClick?: () => void;
}

export const TimeLineItem: FC<ITimeLineItemProps> = ({
	icon,
	isActive,
	title,
	description,
	onClick,
}) => {
	return (
		<div
			className={classNames(styles['time-line-item'], {
				[styles['time-line-item-active']]: isActive,
			})}
			data-testid={`timeline-item${isActive ? '-active' : ''}`}
			onClick={() => isActive && onClick?.()}
		>
			{icon}
			<Flex gap={2} vertical>
				<p className={styles['title']} data-testid="timeline-item-title">
					{title}
				</p>
				<p className={styles['description']} data-testid="timeline-item-description">
					{description}
				</p>
			</Flex>
		</div>
	);
};
